import React, { useState, useRef, useEffect } from "react";
import { Button } from "reactstrap";
import { convertToPersianNumber } from "../../modules/helper";
import { authOTP } from "../../api/auth_otp";

let myInterval;

const VerifyCode = ({
  length,
  onComplete,
  enteredData,
  setCodeError,
  goStepOne,
  editEmailPhone,
  remaining_time,
  stateStep,
  codeError,
}) => {
  const [code, setCode] = useState([...Array(length)].map(() => ""));
  const [state, setState] = useState({
    seconds: Math.floor(remaining_time % 60),
    minutes: Math.floor(remaining_time / 60),
  });

  const inputs = useRef([]);
  const lastCompletedCode = useRef("");
  const processInput = (e, slot) => {
    if (codeError) lastCompletedCode.current = "";

    const digits = e.target.value.replace(/[^0-9۰-۹]/g, "");
    const newCode = [...code];

    if (digits.length > 1) {
      const autoFilledCode = digits.slice(0, length).split("");
      for (let index = 0; index < length; index += 1) {
        newCode[index] = autoFilledCode[index] || "";
      }
      setCode(newCode);
      inputs.current[Math.min(autoFilledCode.length, length) - 1]?.focus();
      return;
    }

    newCode[slot] = digits;
    setCode(newCode);
    if (digits && slot !== length - 1) {
      inputs.current[slot + 1]?.focus();
    }
  };

  const onKeyUp = (e, slot) => {
    if (e.keyCode === 8 && !code[slot] && slot !== 0) {
      const newCode = [...code];
      newCode[slot - 1] = "";
      setCode(newCode);
      inputs.current[slot - 1].focus();
    }
  };

  useEffect(() => {
    if (stateStep === 2) {
      myInterval = setInterval(() => {
        const { seconds, minutes } = state;

        if (seconds > 0) {
          setState((prev) => ({
            ...prev,
            seconds: state.seconds - 1,
          }));
        }

        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(myInterval);
          } else {
            setState((prev) => ({
              ...prev,
              minutes: minutes - 1,
              seconds: 59,
            }));
          }
        }
      }, 1000);

      return () => {
        clearInterval(myInterval);
      };
    }
  }, [state.seconds, state.minutes]);

  function resetTimer() {
    setCode([...Array(length)].map(() => ""));
    setCodeError((prev) => ({ ...prev, codeError: "", loading: true }));

    authOTP({ uid: enteredData })
      .then(function (response) {
        setCodeError((prev) => ({ ...prev, codeError: "", loading: false }));
        setState((prev) => ({
          ...prev,
          seconds: Math.floor(response.data.remaining_seconds % 60),
          minutes: Math.floor(response.data.remaining_seconds / 60),
        }));
      })
      .catch((err) => {
        setCodeError((prev) => ({ ...prev, codeError: "", loading: false }));
      });
  }

  useEffect(() => {
    const completedCode = code.join("");
    if (code.some((digit) => digit.length !== 1)) {
      lastCompletedCode.current = "";
      return;
    }
    if (completedCode === lastCompletedCode.current) return;

    lastCompletedCode.current = completedCode;
    onComplete(completedCode);
  }, [code, onComplete]);

  return (
    <>
      <div>
        <Button className="icon-wrapper" onClick={goStepOne}>
          <span className="icon-arrow_back_black" />
        </Button>
        <div
          className="wrapCodeInput"
          sx={{
            backgroundColor: "background.main",
          }}
        >
          <div className="codeInput">
            <p className="confirmation-code">کد تایید</p>
            <p className="codeLabel">
              <span>لطفا کد ارسال شده به</span>&nbsp;
              {convertToPersianNumber(enteredData)}&nbsp;
              <span>را وارد کنید</span>
            </p>
            <Button color="light" className="codeDetail" onClick={goStepOne}>
              {editEmailPhone}
            </Button>
            <div className="codeInputs">
              {code.map((num, idx) => {
                return (
                  <input
                    type="tel"
                    className={`smsCodes ${
                      codeError
                        ? "there_is_wrong_number"
                        : num
                        ? "there_is_num"
                        : "there_isNot_num"
                    } `}
                    key={idx}
                    value={convertToPersianNumber(num)}
                    inputMode="numeric"
                    autoComplete={idx === 0 ? "one-time-code" : "off"}
                    autoFocus={!code[0].length && idx === 0}
                    onChange={(e) => processInput(e, idx)}
                    onKeyUp={(e) => onKeyUp(e, idx)}
                    maxLength={1}
                    ref={(ref) => {
                      inputs.current[idx] = ref;
                    }}
                  />
                );
              })}
            </div>
            {codeError && (
              <div className="codeError">
                کد وارد شده اشتباه است، لطفا دوباره بررسی کنید
              </div>
            )}

            <div className="resendCode">
              {state.minutes === 0 && state.seconds === 0 ? (
                <>
                  <Button color="light" onClick={resetTimer}>
                    ارسال مجدد کد تایید
                  </Button>
                </>
              ) : (
                <div className="remaining-time">
                  مدت اعتبار:
                  <span
                    dangerouslySetInnerHTML={{
                      __html: "&nbsp; ",
                    }}
                  />
                  <b>
                    {convertToPersianNumber(state.minutes)}:
                    {state.seconds < 10
                      ? `${convertToPersianNumber(0)}${convertToPersianNumber(
                          state.seconds
                        )}`
                      : convertToPersianNumber(state.seconds)}
                  </b>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VerifyCode;
